/**
 * Privacy button handlers for EU compliance through Shopify's native consent management
 */
document.addEventListener('DOMContentLoaded', function () {
  const doNotSellButton = document.getElementById('js-do-not-sell-btn');
  const doNotSellCheck = document.getElementById('js-do-not-sell-check');
  const consentButton = document.getElementById('js-consent-settings-btn');

  initializeShopifyPrivacyAPI(doNotSellCheck);
  setupPrivacyButtons(doNotSellButton, doNotSellCheck, consentButton);
});

/**
 * Initializes Shopify Privacy API and handles initial consent state
 * @param {HTMLElement} doNotSellCheck - The checkmark element to show/hide
 */
function initializeShopifyPrivacyAPI(doNotSellCheck) {
  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1'
      }
    ],
    error => {
      if (error) {
        console.error('Error loading consent-tracking-api feature:', error);
      } else {
        try {
          const countryCode = window.Shopify.customerPrivacy.getRegion();
          const initialConsent =
            window.Shopify.customerPrivacy.currentVisitorConsent();

          // Check if user has already opted out of sale of data
          if (initialConsent && initialConsent.sale_of_data === 'no') {
            if (doNotSellCheck) {
              doNotSellCheck.style.display = 'inline-block';
            }
          }

          transformPrivacyModalForTheUS(countryCode, initialConsent);
        } catch (err) {
          console.error('Error processing initial consent:', err);
        }
      }
    }
  );
}

/**
 * Sets up all privacy-related button event handlers
 * @param {HTMLElement} doNotSellButton - The "Do Not Sell" button element
 * @param {HTMLElement} doNotSellCheck - The checkmark element to show
 * @param {HTMLElement} consentButton - The consent settings button element
 */
function setupPrivacyButtons(doNotSellButton, doNotSellCheck, consentButton) {
  // Handle "Do Not Sell Or Share My Info" button
  if (doNotSellButton) {
    doNotSellButton.addEventListener('click', function (event) {
      event.preventDefault();

      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(
          { sale_of_data: false },
          () => {
            if (doNotSellCheck) {
              doNotSellCheck.style.display = 'inline-block';
            }
          }
        );
      } else {
        console.warn('Shopify Customer Privacy API is not available');
      }
    });
  }

  // Handle "Consent Settings" button
  if (consentButton) {
    consentButton.addEventListener('click', function () {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        privacyBanner.showPreferences();
      } else {
        console.warn('Shopify Customer Privacy API is not available');
      }
    });
  }
}

/**
 * Transforms privacy modal behavior for US users
 * @param {string} countryCode - The country code from Shopify
 * @param {Object} initialConsent - The initial consent object from Shopify
 */
function transformPrivacyModalForTheUS(countryCode, initialConsent) {
  if (!countryCode.startsWith('US')) return;

  const revealBanner = () => {
    const banner = document.getElementById('shopify-pc__banner');
    if (banner) {
      banner.classList.add('privacy-banner-ready');
    }
  };

  const fallbackTimer = setTimeout(() => {
    revealBanner();
  }, 1500);

  const observer = new MutationObserver(() => {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.dataset.customized === 'true') return;

    const acceptBtn = banner.querySelector('#shopify-pc__banner__btn-accept');
    const rejectBtn = banner.querySelector('#shopify-pc__banner__btn-decline');
    const managePrefsBtn = banner.querySelector(
      '#shopify-pc__banner__btn-manage-prefs'
    );
    const preferencesCopy = banner.querySelector('.shopify-pc__banner__body p');

    if (!acceptBtn || !managePrefsBtn) return;

    acceptBtn.innerText = 'Ok, got it';
    if (rejectBtn) {
      rejectBtn.style.display = 'none';
    }

    if (preferencesCopy && preferencesCopy.innerText.includes('Accept All')) {
      preferencesCopy.innerText = preferencesCopy.innerText.replace(
        'Accept All',
        'Ok, got it'
      );
    }

    if (!managePrefsBtn.dataset.listenerAdded) {
      managePrefsBtn.dataset.listenerAdded = 'true';

      managePrefsBtn.addEventListener('click', function () {
        setTimeout(() => {
          handlePreferenceCheckboxes(initialConsent);
        }, 100);
      });
    }

    clearTimeout(fallbackTimer);
    banner.dataset.customized = 'true';
    revealBanner();
    observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

/**
 * Handles automatic checking of preference checkboxes based on initial consent
 * @param {Object} initialConsent - The initial consent object from Shopify
 */
function handlePreferenceCheckboxes(initialConsent) {
  const preferenceOptions = document.querySelector(
    '.shopify-pc__prefs__options'
  );

  if (preferenceOptions) {
    const checkboxMapping = {
      'shopify-pc__prefs__preferences-input': 'preferences', // Personalization
      'shopify-pc__prefs__marketing-input': 'marketing', // Marketing
      'shopify-pc__prefs__analytics-input': 'analytics' // Analytics
    };

    Object.entries(checkboxMapping).forEach(([checkboxId, consentProperty]) => {
      const checkbox = document.getElementById(checkboxId);
      if (checkbox && initialConsent?.[consentProperty] !== 'no') {
        checkbox.click();
      }
    });
  }
}
